export enum LocalStorageKey {
  USER_INTENT = 'user-intent-id',
  NO_INTENT = 'noIntent',
  RE_CHECK = 're-check',
  WT_COMPLETED = 'wt-completed',
  INTRO_COMPLETED = 'intro-completed',
}

// ids for WT_COMPLETED
export enum WalkThroughId {
  FOOD_ID = 'foodid',
  DASHBOARD = 'dashboard',
}
